export const UserStorageKey = "vst_user";
